/**
 * @generated SignedSource<<a8664698d8d0ff5e3a434800c7d10099>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeactivateJiraServerInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deactivateJiraServerMutation$variables = {
  input: DeactivateJiraServerInput;
};
export type deactivateJiraServerMutation$data = {
  readonly deactivateJiraServer: {
    readonly viewer: {
      readonly company: {
        readonly jiraServerPublicRsaKey: string | null;
        readonly jiraServerConsumerKey: string | null;
        readonly jiraServerUrl: string | null;
        readonly jiraServerAccessToken: string | null;
        readonly jiraServerEnabled: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type deactivateJiraServerMutation = {
  variables: deactivateJiraServerMutation$variables;
  response: deactivateJiraServerMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerPublicRsaKey",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerConsumerKey",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerAccessToken",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerEnabled",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deactivateJiraServerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateJiraServerPayload",
        "kind": "LinkedField",
        "name": "deactivateJiraServer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deactivateJiraServerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateJiraServerPayload",
        "kind": "LinkedField",
        "name": "deactivateJiraServer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aaf25979c79373c7fd5207b4dc46aab4",
    "id": null,
    "metadata": {},
    "name": "deactivateJiraServerMutation",
    "operationKind": "mutation",
    "text": "mutation deactivateJiraServerMutation(\n  $input: DeactivateJiraServerInput!\n) {\n  deactivateJiraServer(input: $input) {\n    viewer {\n      company {\n        jiraServerPublicRsaKey\n        jiraServerConsumerKey\n        jiraServerUrl\n        jiraServerAccessToken\n        jiraServerEnabled\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ea7d8b129f089d2351c1aadf289f86c";

export default node;
